import { DATA_QCD } from './getObsufcatdAttributes';
import { DATA_TRACKING_CLICK_DISABLED } from './getTrackingAttributes';

export const _allButtonsSelector = [
  'a',
  'button',
  '[tabindex]:not([tabindex="-1"])',
  `[${DATA_QCD}]`,
  'summary',
  '.Modal',
];

export const allButtonsSelector = _allButtonsSelector.join(
  `:not([${DATA_TRACKING_CLICK_DISABLED}="true"]),`,
);
